import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { LoaderOverlayService } from 'src/app/core/services/loader-overlay.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { MenuService } from 'src/app/shared/services/menu.service';
import { ViewCartService } from 'src/app/shared/services/view-cart.service';
import { ExpandImageDialogComponent } from 'src/app/modules/store/expand-image-dialog/expand-image-dialog.component';
import { SwiperOptions } from 'swiper';
import { ApplyRewardDialogComponent } from '../apply-reward-dialog/apply-reward-dialog.component';
import { Subject } from 'rxjs';
import { delay, retryWhen, take, takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { StorageService } from 'src/app/shared/services/storage.service';
import { LocationAlertDialogComponent } from '../location-alert-dialog/location-alert-dialog.component';
import { StoreService } from 'src/app/shared/services/store.service';
import * as LZString from 'lz-string';
declare var dataLayer;
@Component({
  selector: 'app-product-customization',
  templateUrl: './product-customization.component.html',
  styleUrls: ['./product-customization.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductCustomizationComponent implements OnInit, OnChanges, OnDestroy {
  endsubs$: Subject<any> = new Subject();
  public isPhone: boolean;
  public title = 'Product Detail | Tata Starbucks';
  public noOfpannel: string = '';
  public itemType: boolean = true;
  public activeMenu = sessionStorage.getItem('activeMenu');
  public menuListData: any;
  public storeDetails: any;
  public panelOpenState = false;
  public panelOpenState1 = false;
  public panelOpenState2 = false;
  public selectedItem;
  public favouriteItem;
  public breadcrumbTitle: string;
  public isFavouriteProduct: boolean;
  public favouriteItem_modfierId = [];
  public breadCrumbData: Array<Object>;
  public mid = [];
  public catItem = '';
  public adOnItem = '';
  public showWithoutComma: boolean = true;
  public showAdOnWithoutComma: boolean = false;
  public cartItems = JSON.parse(sessionStorage.getItem('snackbarData'));
  public priceArray = [];
  public cartDataId_CusTab = [];
  public midAddon = [];
  public cartDataId_addTab = [];
  public midCondiments = [];
  public cartDataId_condTab = [];
  public step = 0;
  public addonArray = [];
  public counter = 0;
  public basePriceArray = [];
  public customiseTotal = [];
  public sumCustomise: number;
  public addOnTotal = [];
  public sumAddOn: number;
  public isClicked: boolean = false;
  public allBasketItem;
  public reqBodycustomiseArray = [];
  public reqaddOnsArray = [];
  public reqCondimentsArray = [];
  public itemInCart;
  public finalReqBodyArray = [];
  public addNewItem: boolean = false;
  public filteredCartItem;
  public customiseArray = [];
  public addOnsArray = [];
  public condimentsArray = [];
  public titleData = [];
  public textTitle;
  public defaultSelections = [];
  public cloned_Selected;
  public isdefault: boolean = true;
  public baristaInfo: Object;
  public activeBasketRes: any;
  public basketId;
  public createBasketRes: any;
  public condimentTotal = [];
  public sumCondiments: number;
  public stdClicked: boolean = false;
  public userType: string;
  public userId: any;
  public tierType: any;
  public gaData: any = [];
  public selectedItemGA: any;
  public storeList: any = [];
  public noStoreFound: boolean;
  public workingStoreOnline: any = [];
  public urlPath: string[];
  public categoryName: string;
  public productName: string;
  public category;
  public product;
  public findItem: boolean;
  public strictCustomise: boolean;
  public strictaddons: boolean;
  public strictCondiments: boolean;
  constructor(
    private router: Router,
    private _bottomSheet: MatBottomSheet,
    private cartService: ViewCartService,
    private menuService: MenuService,
    private titleService: Title,
    private commonFunction: CommonFunctions,
    private loaderOverlayService: LoaderOverlayService,
    private storageService: StorageService,
    private storeService: StoreService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.getMenu();
    this.isPhone = this.commonFunction.identifyDeviceType();
    this.titleService.setTitle(this.title);
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    this.loadProduct();
    let checkGAData = JSON.parse(sessionStorage.getItem('gaData'));
    this.gaData = checkGAData ? checkGAData : [];
  }
  ngOnDestroy() {
    this.endsubs$.next();
    this.endsubs$.complete();
    sessionStorage.removeItem('updateCart');
  }
  ngOnChanges(): void { }
  ngAfterViewInit(): void { }
  public txtWithoutComma() {
    this.cdr.detectChanges();
    this.catItem = '';
    let elements = document.getElementsByClassName(
      'innerCat'
    ) as HTMLCollectionOf<HTMLElement>;
    if (elements.length != 0) {
      for (let i = 0; i < elements.length; i++) {
        let text = elements[i].innerText;
        if (text != '') {
          this.catItem = this.catItem + text;
        }
      }
    }
    this.catItem = this.catItem.replace(/,\s*$/, '');
  }
  public addOnWithoutComma() {
    this.cdr.detectChanges();
    this.adOnItem = '';
    let text = '';
    let elements = document.getElementsByClassName(
      'innerAdOn'
    ) as HTMLCollectionOf<HTMLElement>;
    if (elements.length != 0) {
      text = elements !== undefined ? elements[0].innerText : '';
      if (text.length > 0) {
        this.showAdOnWithoutComma = true;
      } else {
        this.showAdOnWithoutComma = false;
      }
    }
    text = text.replace(/,\s*$/, '');
    this.adOnItem = text;
  }
  public getSelectedItem(isLoggedIn) {
    this.priceArray = [];
    this.favouriteItem_modfierId = [];
    this.selectedItem = JSON.parse(localStorage.getItem('selectedItem'));
    this.priceArray.push(this.selectedItem['defaultPrice']);
    this.selectedItem['customPrice'] = this.selectedItem['defaultPrice'];
    let productForCustomisation = JSON.parse(
      sessionStorage.getItem('productForCustomisation')
    );
    this.breadcrumbTitle = this.selectedItem.name;
    this.setBreadcrumb(this.breadcrumbTitle);
    this.setDyanmicPannel(this.selectedItem);
    if (productForCustomisation) {
      this.cutomizationFromCart(productForCustomisation);
    } else {
      this.cutomizationFromMenu(isLoggedIn);
    }
    this.txtWithoutComma();
    this.addOnWithoutComma();
  }
  public cutomizationFromCart(productForCustomisation) {
    this.selectedItem['options'] != null
      ? this.customiseDataTab_cart(
        this.selectedItem['options']['customization'],
        productForCustomisation
      )
      : '';
    this.selectedItem['options'] != null
      ? this.customiseAddONTab_cart(
        this.selectedItem['options']['addons'],
        productForCustomisation
      )
      : '';
    this.selectedItem['options'] != null
      ? this.customiseCondimentsTab_cart(
        this.selectedItem['options']['condiments'],
        productForCustomisation
      )
      : '';
    this.setGrandTotal();
  }
  public cutomizationFromMenu(isLoggedIn) {
    if (isLoggedIn) {
      let favouriteItem = JSON.parse(sessionStorage.getItem('favouriteItem'));
      this.favouriteItem = this.checkFavourite(
        favouriteItem,
        this.selectedItem
      );
      if (this.favouriteItem && this.favouriteItem.length != 0) {
        this.selectedItem['options'] != null
          ? this.customiseDataTab(
            this.selectedItem['options']['customization'],
            this.favouriteItem
          )
          : '';
        this.selectedItem['options'] != null
          ? this.customiseAddONTab(
            this.selectedItem['options']['addons'],
            this.favouriteItem
          )
          : '';
        this.selectedItem['options'] != null
          ? this.customiseCondimentsTab(
            this.selectedItem['options']['condiments'],
            this.favouriteItem
          )
          : '';
      } else {
        this.selectedItem['options'] != null
          ? this.customiseDataTab(
            this.selectedItem['options']['customization'],
            []
          )
          : '';
        this.selectedItem['options'] != null
          ? this.customiseAddONTab(this.selectedItem['options']['addons'], [])
          : '';
        this.selectedItem['options'] != null
          ? this.customiseCondimentsTab(
            this.selectedItem['options']['condiments'],
            []
          )
          : '';
      }
    } else {
      this.selectedItem['options'] != null
        ? this.customiseDataTab(
          this.selectedItem['options']['customization'],
          []
        )
        : '';
      this.selectedItem['options'] != null
        ? this.customiseAddONTab(this.selectedItem['options']['addons'], [])
        : '';
      this.selectedItem['options'] != null
        ? this.customiseCondimentsTab(
          this.selectedItem['options']['condiments'],
          []
        )
        : '';
    }
    this.setGrandTotal();
  }
  public checkFavourite(favouriteItem, selectedItem) {
    if (favouriteItem) {
      for (let i = 0; i < favouriteItem.length; i++) {
        if (favouriteItem[i]['productId'] === selectedItem['id']) {
          this.isFavouriteProduct = true;
          selectedItem['isFavourite'] = true;
          return favouriteItem[i];
        } else {
          this.isFavouriteProduct = false;
        }
      }
    } else {
      this.isFavouriteProduct = false;
    }
  }
  public setBreadcrumb(breadcrumbTitle) {
    let previosPage = sessionStorage.getItem('previosPage');
    let breadCrumbData;
    let navPath = this.activeMenu === 'Banner' ? 'giftcards' : 'ordering';
    if (previosPage && previosPage === 'Menu') {
      breadCrumbData = [
        {
          title: 'Order',
          path: 'ordering',
        },
        {
          title: this.activeMenu,
          path: navPath,
        },
        {
          title: 'Product title',
        },
      ];
    } else {
      breadCrumbData = [
        {
          title: this.activeMenu,
          path: 'ordering',
        },
        {
          title: 'Product title',
        },
      ];
    }
    this.breadCrumbData = breadCrumbData.map((item) => {
      return item.title === 'Product title'
        ? { ...item, title: breadcrumbTitle }
        : item;
    });
  }
  public setDyanmicPannel(selectedItem) {
    if (selectedItem['options'] === null || selectedItem['options'] === undefined) {
      this.noOfpannel = 'zero';
    } else {
      let addonsLength1 =
        selectedItem['options']['addons'] &&
        selectedItem['options']['addons']['modifiersItems'].length;
      let condimentsLength1 =
        selectedItem['options']['condiments'] &&
        selectedItem['options']['condiments']['modifiersItems'].length;
      let customizationLength1 =
        selectedItem['options']['customization'] &&
        selectedItem['options']['customization']['modifiersItems'].length;
      let addonsLength = addonsLength1 ? addonsLength1 : 0;
      let condimentsLength = condimentsLength1 ? condimentsLength1 : 0;
      let customizationLength = customizationLength1 ? customizationLength1 : 0;
      if (
        addonsLength != 0 &&
        condimentsLength != 0 &&
        customizationLength != 0
      ) {
        this.noOfpannel = 'three';
      } else if (
        addonsLength === 0 &&
        condimentsLength === 0 &&
        customizationLength === 0
      ) {
        this.noOfpannel = 'zero';
      } else if (
        addonsLength === 0 &&
        condimentsLength != 0 &&
        customizationLength != 0
      ) {
        this.noOfpannel = 'two';
      } else if (
        addonsLength != 0 &&
        condimentsLength === 0 &&
        customizationLength != 0
      ) {
        this.noOfpannel = 'two';
      } else if (
        addonsLength != 0 &&
        condimentsLength != 0 &&
        customizationLength === 0
      ) {
        this.noOfpannel = 'two';
      } else if (
        addonsLength === 0 &&
        condimentsLength === 0 &&
        customizationLength != 0
      ) {
        this.noOfpannel = 'one';
      } else if (
        addonsLength === 0 &&
        condimentsLength != 0 &&
        customizationLength === 0
      ) {
        this.noOfpannel = 'one';
      } else if (
        addonsLength != 0 &&
        condimentsLength === 0 &&
        customizationLength === 0
      ) {
        this.noOfpannel = 'one';
      }
    }
  }
  public customiseDataTab(customiseData, favouriteItem) {
    if (customiseData && customiseData.modifiersItems.length != 0) {
      if (
        favouriteItem['modifiers'] &&
        favouriteItem['modifiers'].length != 0
      ) {
        this.mid = [];
        for (let i = 0; i < favouriteItem['modifiers'].length; i++) {
          this.mid.push(favouriteItem['modifiers'][i]['modifierId']);
        }
        customiseData.modifiersItems &&
          customiseData.modifiersItems.map((res) => {
            res['items'].map((itm) => {
              this.mid.includes(itm['id'])
                ? (itm['click'] = true)
                : (itm['click'] = false);
            });
          });
        let a = JSON.parse(sessionStorage.getItem('defaultSelectionsFav'));
        let b = customiseData['modifiersItems'];
        let a1 = JSON.stringify(a);
        let b1 = JSON.stringify(b);
        a1 === b1 ? (this.isdefault = true) : (this.isdefault = false);
      } else {
        customiseData.modifiersItems &&
          customiseData.modifiersItems.map((res) => {
            res['items'].map((itm) => {
              res['defaultItemIds'][0] === itm['id']
                ? (itm['click'] = true)
                : (itm['click'] = false);
            });
          });
        let defaultSelections = customiseData.modifiersItems.map((obj) => {
          return { ...obj };
        });
        sessionStorage.setItem(
          'defaultSelectionsRegular',
          JSON.stringify(defaultSelections)
        );
      }
      this.setPrice();
    }
  }
  public customiseDataTab_cart(customiseData, cartData) {
    let defaultSelections = JSON.parse(
      sessionStorage.getItem('defaultSelections')
    );
    if (
      customiseData.modifiersItems &&
      customiseData.modifiersItems.length != 0
    ) {
      this.cartDataId_CusTab = [];
      if (this.stdClicked && defaultSelections) {
        defaultSelections.map((itmss) => {
          itmss['items'].map((itm) => {
            if (itm['click']) {
              this.cartDataId_CusTab.push(itm.id);
            }
          });
        });
      } else {
        if (cartData['options']) {
          cartData['options'].map((res) => {
            res['selections'].map((itm) => {
              this.cartDataId_CusTab.push(itm.id);
            });
          });
        }
      }
      customiseData.modifiersItems.map((res) => {
        res['items'].map((itm) => {
          this.cartDataId_CusTab.includes(itm['id'])
            ? (itm['click'] = true)
            : (itm['click'] = false);
        });
      });
    }
    let a = JSON.parse(sessionStorage.getItem('defaultSelections'));
    let b = customiseData['modifiersItems'];
    let a1 = JSON.stringify(a);
    let b1 = JSON.stringify(b);
    a1 === b1 ? (this.isdefault = true) : (this.isdefault = false);
    this.setPrice();
  }
  public customiseAddONTab(addonsData, favouriteItem) {
    if (addonsData && addonsData.modifiersItems.length != 0) {
      if (
        favouriteItem['modifiers'] &&
        favouriteItem['modifiers'].length != 0
      ) {
        this.midAddon = [];
        for (let i = 0; i < favouriteItem['modifiers'].length; i++) {
          this.midAddon.push(favouriteItem['modifiers'][i]['modifierId']);
        }
        addonsData.modifiersItems.map((res) => {
          res['items'].map((itm) => {
            this.midAddon.includes(itm['id'])
              ? (itm['selectedQty'] = 1)
              : (itm['selectedQty'] = 0);
          });
        });
      } else {
        addonsData.modifiersItems.map((res) => {
          res['items'].map((itm) => {
            if (res['defaultItemIds'].includes(itm.id)) {
              itm['selectedQty'] = 1;
            } else {
              itm['selectedQty']
                ? itm['selectedQty']
                : (itm['selectedQty'] = 0);
            }
          });
        });
      }
    }
    this.setPriceAddOn();
  }
  public customiseAddONTab_cart(addonsData, cartData) {
    this.cartDataId_addTab = [];
    if (addonsData && addonsData.modifiersItems.length != 0) {
      cartData['options'].map((res) => {
        res['selections'].map((itm) => {
          this.cartDataId_addTab.push(itm.id);
        });
      });
      addonsData.modifiersItems.map((res) => {
        res['items'].map((itm) => {
          this.cartDataId_addTab.includes(itm['id'])
            ? (itm['selectedQty'] = 1)
            : (itm['selectedQty'] = 0);
        });
      });
    }
    this.setPriceAddOn();
  }
  public customiseCondimentsTab(condiments, favouriteItem) {
    if (condiments && condiments.modifiersItems.length != 0) {
      if (
        favouriteItem['modifiers'] &&
        favouriteItem['modifiers'].length != 0
      ) {
        this.midCondiments = [];
        for (let i = 0; i < favouriteItem['modifiers'].length; i++) {
          this.midCondiments.push(favouriteItem['modifiers'][i]['modifierId']);
        }
        condiments.modifiersItems.map((res) => {
          res['items'].map((itm) => {
            this.midCondiments.includes(itm['id'])
              ? (itm['selectedQty'] = 1)
              : (itm['selectedQty'] = 0);
          });
        });
      } else {
        condiments.modifiersItems.map((res) => {
          res['items'].map((itm) => {
            if (res['defaultItemIds'].includes(itm.id)) {
              itm['selectedQty'] = 1;
            } else {
              itm['selectedQty']
                ? itm['selectedQty']
                : (itm['selectedQty'] = 0);
            }
          });
        });
      }
    }
    this.setPriceCondiments();
  }
  public customiseCondimentsTab_cart(condiments, cartData) {
    this.cartDataId_condTab = [];
    if (condiments && condiments.modifiersItems.length != 0) {
      cartData['options'].map((res) => {
        res['selections'].map((itm) => {
          this.cartDataId_condTab.push(itm.id);
        });
      });
      condiments.modifiersItems.map((res) => {
        res['items'].map((itm) => {
          this.cartDataId_condTab.includes(itm['id'])
            ? (itm['selectedQty'] = 1)
            : (itm['selectedQty'] = 0);
        });
      });
    }
    this.setPriceCondiments();
  }
  public setStep(index: number) {
    this.step = index;
  }
  public nextStep() {
    this.step++;
  }
  public prevStep() {
    this.step--;
  }
  @HostListener('window:popstate', ['$event'])
  public onPopState(event) {
    const navigationExtras: NavigationExtras = {
      state: {
        data: this.menuListData,
        storeDetails: this.storeDetails,
        module: 'breadcrumb',
      },
    };
    this.router.navigate(['/ordering'], navigationExtras);
  }
  public backTo() {
    this.isClicked = this.loaderOverlayService.hideShimmerBtn();
    const navigationExtras: NavigationExtras = {
      state: {
        data: this.menuListData,
        storeDetails: this.storeDetails,
        module: 'breadcrumb',
      },
    };
    let previosPage = sessionStorage.getItem('previosPage');
    if (
      (previosPage && previosPage === 'Cart') ||
      (previosPage && previosPage === 'CartPDP')
    ) {
      this.router.navigate(['/cart'], navigationExtras);
    } else if (previosPage && previosPage === 'Home') {
      this.router.navigate(['/dashboard']);
    } else if (previosPage && previosPage === 'Promotion Banner') {
      this.router.navigate(['/dashboard/banner-detail']);
    } else if (previosPage && previosPage === 'Global Search') {
      this.router.navigate(['/search']);
    } else {
      this.router.navigate(['/ordering'], navigationExtras);
    }
  }
  public getMenu() {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state as {
      allMenuList: any;
      storeDetails: any;
    };
    if (state?.allMenuList) {
      this.menuListData = state?.allMenuList;
      this.storeDetails = state?.storeDetails;
    } else {
    }
  }
  public setToDefault(event) {
    if (event) {
      this.isdefault = true;
      this.stdClicked = true;
      let isLoggedIn = this.commonFunction.verifyLoggedInUser();
      this.getSelectedItem(isLoggedIn);
    }
  }
  public closePanels(event) {
    if (event) {
      this.panelOpenState = false;
      this.panelOpenState1 = false;
      this.panelOpenState2 = false;
    }
  }
  public increment(item, i, category) {
    if (category.allowMultipleQuantity) {
      this.selectedItem.defaultPrice += item.basePrice;
      item['selectedQty'] < 99 ? item['selectedQty']++ : '';
    } else {
      let totalQTY = category['items'].reduce(
        (n, { selectedQty }) => n + selectedQty,
        0
      );
      if (totalQTY < category.selectionCriteria) {
        if (item['selectedQty'] < 1) {
          this.selectedItem.defaultPrice += item.basePrice;
        } else {
          this.openSnacBar();
        }
        item['selectedQty'] < 1 ? item['selectedQty']++ : '';
      } else {
        this.openSnacBar();
      }
    }
    this.addOnWithoutComma();
  }
  public openSnacBar() {
    let mssg = "You can't select multiple quantity";
    this.commonFunction.displaySnackBarMessage(mssg, 'alert');
  }
  public decrement(item, i) {
    item['selectedQty'] > 0
      ? (this.selectedItem.defaultPrice -= item.basePrice)
      : '';
    item['selectedQty'] != 0 ? item['selectedQty']-- : '';
    this.addOnWithoutComma();
  }
  public incrementCond(item, i, category) {
    if (category.allowMultipleQuantity) {
      this.selectedItem.defaultPrice += item.basePrice;
      item['selectedQty'] < 99 ? item['selectedQty']++ : '';
    } else {
      let totalQTY = category['items'].reduce(
        (n, { selectedQty }) => n + selectedQty,
        0
      );
      if (totalQTY < category.selectionCriteria) {
        if (item['selectedQty'] < 1) {
          this.selectedItem.defaultPrice += item.basePrice;
        }
        item['selectedQty'] < 1 ? item['selectedQty']++ : '';
      } else {
      }
    }
  }
  public decrementCond(item, i) {
    item['selectedQty'] > 0
      ? (this.selectedItem.defaultPrice -= item.basePrice)
      : '';
    item['selectedQty'] != 0 ? item['selectedQty']-- : '';
  }
  public selectedCustProduct(category, defaultItemIds, j, categoryyy) {
    this.selectedItem.defaultPrice += category.basePrice;
    if (categoryyy.strictSelection) {
      category['click'] = true;
    } else {
      category['click'] = !category['click'];
    }
    for (let i = 0; i < categoryyy['items'].length; i++) {
      if (i != j) {
        categoryyy['items'][i].click = false;
      }
    }
    let everyClick = categoryyy['items'].every((e) => e.click === false);
    if (everyClick && categoryyy['strictSelection']) {
      let item_with_matched_id = categoryyy['items'].find(
        (item) => item.id === defaultItemIds
      );
      item_with_matched_id['click'] = true;
    }
  }
  public selectedCustProduct1(
    category,
    defaultItemIds,
    j,
    categoryyy,
    cutomisationData
  ) {
    if (categoryyy.strictSelection && categoryyy['selectionCriteria'] === 1) {
      category['click'] = true;
      for (let i = 0; i < categoryyy['items'].length; i++) {
        if (i != j) {
          categoryyy['items'][i].click = false;
        }
      }
    } else if (
      categoryyy.strictSelection &&
      categoryyy['selectionCriteria'] != 1
    ) {
      let total_clicktrue = categoryyy['items'].filter((res) => res['click']);
      if (total_clicktrue.length < categoryyy['selectionCriteria']) {
        category['click'] = true;
      } else {
        if (category['click']) {
          category['click'] = !category['click'];
        } else {
          this.openSnacBar();
        }
      }
    } else if (
      !categoryyy.strictSelection &&
      categoryyy['selectionCriteria'] != 1
    ) {
      let total_clicktrue = categoryyy['items'].filter((res) => res['click']);
      if (total_clicktrue.length < categoryyy['selectionCriteria']) {
        category['click'] = true;
      } else {
        if (category['click']) {
          category['click'] = !category['click'];
        } else {
          this.openSnacBar();
        }
      }
    } else {
      category['click'] = !category['click'];
      for (let i = 0; i < categoryyy['items'].length; i++) {
        if (i != j) {
          categoryyy['items'][i].click = false;
        }
      }
    }
    let previousPage = sessionStorage.getItem('previosPage');
    if (previousPage === 'Cart') {
      this.customSelection(cutomisationData);
    } else {
      this.isFavouriteProduct
        ? this.customSelectionFav(cutomisationData)
        : this.customSelectionRegular(cutomisationData);
    }
    this.txtWithoutComma();
    this.setPrice();
  }
  public setPrice() {
    this.customiseTotal = [];
    if (
      this.selectedItem['options'] &&
      this.selectedItem['options']['customization']
    ) {
      if (
        this.selectedItem['options']['customization']['modifiersItems'] &&
        this.selectedItem['options']['customization']['modifiersItems']
          .length != 0
      ) {
        this.selectedItem['options']['customization']['modifiersItems'].forEach(
          (item) => {
            item['items'].forEach((data) => {
              if (data['click']) {
                this.customiseTotal.push(data['defaultPrice']);
              }
            });
          }
        );
      }
    }
    this.sumCustomise = this.customiseTotal.reduce(
      (partialSum, a) => partialSum + a,
      0
    );
    this.sumCustomise > 0 ? this.sumCustomise : (this.sumCustomise = 0);
    this.setGrandTotal();
  }
  public setPriceAddOn() {
    this.addOnTotal = [];
    if (
      this.selectedItem['options'] &&
      this.selectedItem['options']['addons']
    ) {
      if (
        this.selectedItem['options']['addons']['modifiersItems'] &&
        this.selectedItem['options']['addons']['modifiersItems'].length != 0
      ) {
        this.selectedItem['options']['addons']['modifiersItems'].forEach(
          (item) => {
            item['items'].forEach((data) => {
              if (data['selectedQty'] > 0) {
                this.addOnTotal.push(data['defaultPrice']);
              }
            });
          }
        );
      }
    }
    this.sumAddOn = this.addOnTotal.reduce(
      (partialSum, a) => partialSum + a,
      0
    );
    this.sumAddOn > 0 ? this.sumAddOn : (this.sumAddOn = 0);
    this.setGrandTotal();
  }
  public setPriceCondiments() {
    this.condimentTotal = [];
    if (
      this.selectedItem['options'] &&
      this.selectedItem['options']['condiments']
    ) {
      if (
        this.selectedItem['options']['condiments']['modifiersItems'] &&
        this.selectedItem['options']['condiments']['modifiersItems'].length != 0
      ) {
        this.selectedItem['options']['condiments']['modifiersItems'].forEach(
          (item) => {
            item['items'].forEach((data) => {
              if (data['selectedQty'] > 0) {
                this.condimentTotal.push(data['defaultPrice']);
              }
            });
          }
        );
      }
    }
    this.sumCondiments = this.condimentTotal.reduce(
      (partialSum, a) => partialSum + a,
      0
    );
    this.sumCondiments > 0 ? this.sumCondiments : (this.sumCondiments = 0);
    this.setGrandTotal();
  }
  public setGrandTotal() {
    this.sumCustomise ? this.sumCustomise : (this.sumCustomise = 0);
    this.sumAddOn ? this.sumAddOn : (this.sumAddOn = 0);
    this.sumCondiments ? this.sumCondiments : (this.sumCondiments = 0);
    let total = this.sumCustomise + this.sumAddOn + this.sumCondiments;
    this.selectedItem.defaultPrice = this.priceArray[0];
    this.selectedItem.defaultPrice += total;
  }
  public addItemEvent: boolean;
  public addtoCart(selectedItem) {
    this.selectedItemGA = selectedItem;
    this.addItemEvent = true;
    let previosPage = sessionStorage.getItem('previosPage');
    if (previosPage && previosPage === 'Cart') {
      this.updateCartData(selectedItem);
      this.isClicked = true;
    } else {
      this.isClicked = this.loaderOverlayService.showShimmerBtn();
      let basketId = this.storageService.getBasketId();
      basketId
        ? this.makeReqBody(selectedItem)
        : this.getactivebasket(selectedItem);
    }
    sessionStorage.removeItem('reloadedCard');
    sessionStorage.removeItem('reloadCardPay');
  }
  public updateCartData(item) {
    let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
    let filteredProd = snackbarData['response']['items'].filter(
      (data) => +data['id'] === +item['id']
    );
    if (filteredProd && filteredProd.length === 0) {
      this.isClicked = this.loaderOverlayService.showShimmerBtn();
      let basketId = this.storageService.getBasketId();
      basketId ? this.makeReqBody(item) : this.getactivebasket(item);
    } else {
      let basketId = this.storageService.getBasketId();
      let reqBody = {
        basketId: basketId,
        lineItemId: filteredProd[0].lineItemId,
        id: filteredProd[0].id,
        quantity: filteredProd[0].quantity,
      };
      if (!item['options']) {
        reqBody['options'] = [];
      } else if (
        !item['options']['addons'] &&
        !item['options']['condiments'] &&
        !item['options']['customization']
      ) {
        reqBody['options'] = [];
      } else if (
        item['options']['addons'] &&
        item['options']['customization'] &&
        !item['options']['condiments']
      ) {
        let reqBodycustomiseArray = this.reqBodyCustoimseTab(
          item['options']['customization']['modifiersItems']
        );
        let reqaddOnsArray = this.reqBodyAddonsTab(
          item['options']['addons']['modifiersItems']
        );
        let final = [...reqBodycustomiseArray, ...reqaddOnsArray];
        reqBody['options'] = final;
      } else if (
        item['options']['customization'] &&
        !item['options']['addons'] &&
        !item['options']['condiments']
      ) {
        let reqBodycustomiseArray = this.reqBodyCustoimseTab(
          item['options']['customization']['modifiersItems']
        );
        reqBody['options'] = reqBodycustomiseArray;
      } else if (
        !item['options']['addons'] &&
        item['options']['condiments'] &&
        item['options']['customization']
      ) {
        let reqBodycustomiseArray = this.reqBodyCustoimseTab(
          item['options']['customization']['modifiersItems']
        );
        let reqCondimentsArray = this.reqBodyCondimentsTab(
          item['options']['condiments']['modifiersItems']
        );
        let final = [...reqBodycustomiseArray, ...reqCondimentsArray];
        reqBody['options'] = final;
      } else if (
        item['options']['addons'] &&
        item['options']['condiments'] &&
        item['options']['customization']
      ) {
        let reqaddOnsArray = this.reqBodyAddonsTab(
          item['options']['addons']['modifiersItems']
        );
        let reqCondimentsArray = this.reqBodyCondimentsTab(
          item['options']['condiments']['modifiersItems']
        );
        let reqBodycustomiseArray = this.reqBodyCustoimseTab(
          item['options']['customization']['modifiersItems']
        );
        let final = [
          ...reqaddOnsArray,
          ...reqBodycustomiseArray,
          ...reqCondimentsArray,
        ];
        reqBody['options'] = final;
      } else if(item['options']['addons'] &&
        !item['options']['condiments'] &&
        !item['options']['customization']){
          let reqaddOnsArray = this.reqBodyAddonsTab(
            item['options']['addons']['modifiersItems']
          );
          let final = [
            ...reqaddOnsArray
          ];
          reqBody['options'] = final;
      }
      this.cartService
        .updateLineItem(reqBody)
        .pipe(takeUntil(this.endsubs$))
        .subscribe(
          (res) => {
            if (res) {
              this.updatedCart();
            }
            this.loaderOverlayService.hideLoader();
          },
          (error) => {
            this.loaderOverlayService.hideLoader();
            this.showError(error);
          }
        );
    }
  }
  public updatedCart() {
    let basketId = this.storageService.getBasketId();
    let data = {
      basketId: basketId,
    };
    this.cartService
      .getbasketItem(data)
      .pipe(takeUntil(this.endsubs$))
      .subscribe((res) => {
        localStorage.setItem('snackbarData', JSON.stringify(res));
        this.router.navigate(['/cart']);
      });
  }
  public makeReqBody(item) {
    let basketId = this.storageService.getBasketId();
    let data = {
      basketId: basketId,
    };
    this.cartService
      .getbasketItem(data)
      .pipe(takeUntil(this.endsubs$))
      .subscribe(
        (res) => {
          this.allBasketItem = res['response'];
          this.finalReqBody(item, this.allBasketItem);
        },
        (error) => {
          this.finalReqBody(item, []);
          this.showError(error);
        }
      );
  }
  public itemAdding;
  public finalReqBody(item, allBasketItem) {
    this.itemAdding = item;
    let basketId = this.storageService.getBasketId();
    let reqBody = {
      basketId: basketId,
      id: item['id'],
      quantity: 1,
    };
    if (!item['options']) {
      reqBody['options'] = [];
    } else if (
      !item['options']['addons'] &&
      !item['options']['condiments'] &&
      !item['options']['customization']
    ) {
      reqBody['options'] = [];
    } else if (
      item['options']['addons'] &&
      item['options']['customization'] &&
      !item['options']['condiments']
    ) {
      let reqBodycustomiseArray = this.reqBodyCustoimseTab(
        item['options']['customization']['modifiersItems']
      );
      let reqaddOnsArray = this.reqBodyAddonsTab(
        item['options']['addons']['modifiersItems']
      );
      let final = [...reqBodycustomiseArray, ...reqaddOnsArray];
      reqBody['options'] = final;
    } else if (
      item['options']['customization'] &&
      !item['options']['addons'] &&
      !item['options']['condiments']
    ) {
      let reqBodycustomiseArray = this.reqBodyCustoimseTab(
        item['options']['customization']['modifiersItems']
      );
      reqBody['options'] = reqBodycustomiseArray;
    } else if (
      !item['options']['addons'] &&
      item['options']['condiments'] &&
      item['options']['customization']
    ) {
      let reqBodycustomiseArray = this.reqBodyCustoimseTab(
        item['options']['customization']['modifiersItems']
      );
      let reqCondimentsArray = this.reqBodyCondimentsTab(
        item['options']['condiments']['modifiersItems']
      );
      let final = [...reqBodycustomiseArray, ...reqCondimentsArray];
      reqBody['options'] = final;
    } else if (
      item['options']['addons'] &&
      item['options']['condiments'] &&
      item['options']['customization']
    ) {
      let reqaddOnsArray = this.reqBodyAddonsTab(
        item['options']['addons']['modifiersItems']
      );
      let reqCondimentsArray = this.reqBodyCondimentsTab(
        item['options']['condiments']['modifiersItems']
      );
      let reqBodycustomiseArray = this.reqBodyCustoimseTab(
        item['options']['customization']['modifiersItems']
      );
      let final = [
        ...reqaddOnsArray,
        ...reqBodycustomiseArray,
        ...reqCondimentsArray,
      ];
      reqBody['options'] = final;
    }else if(item['options']['addons'] &&
      !item['options']['condiments'] &&
      !item['options']['customization']){
        let reqaddOnsArray = this.reqBodyAddonsTab(
          item['options']['addons']['modifiersItems']
        );
        let final = [
          ...reqaddOnsArray
        ];
        reqBody['options'] = final;
    }
    this.addItemInBasket(reqBody, item, allBasketItem);
  }
  public reqBodyCustoimseTab(modifier) {
    this.reqBodycustomiseArray = [];
    let strictSelection = [];
    for (let i = 0; i < modifier.length; i++) {
      modifier[i]['strictSelection']
        ? strictSelection.push(modifier[i]['id'])
        : '';
      for (let j = 0; j < modifier[i]['items'].length; j++) {
        if (
          modifier[i]['items'][j]['click'] &&
          modifier[i]['items'][j]['inStock']
        ) {
          let obj = {
            id: modifier[i]['id'],
            selections: [
              {
                id: modifier[i]['items'][j]['id'],
                quantity: 1,
              },
            ],
          };
          this.reqBodycustomiseArray.push(obj);
        }
      }
    }
    if (strictSelection.length != 0) {
      if (this.reqBodycustomiseArray.length === 0) {
        this.strictCustomise = true;
      } else {
        let mid = [];
        this.reqBodycustomiseArray.forEach((data) => {
          mid.push(data['id']);
        });
        strictSelection.forEach((ids) => {
          if (mid.includes(ids)) {
            this.strictCustomise = false;
          } else {
            this.strictCustomise = true;
          }
        });
      }
    } else {
      this.strictCustomise = false;
    }
    if (this.strictCustomise) {
      this.commonFunction.displaySnackBarMessage(
        'Please select mandatory customisation',
        'failure'
      );
      this.isClicked = this.loaderOverlayService.hideShimmerBtn();
      this.addItemEvent = false;
      return;
    } else {
      return this.reqBodycustomiseArray;
    }
  }
  public reqBodyAddonsTab(modifier) {
    this.reqaddOnsArray = [];
    let strictSelection = [];
    for (let i = 0; i < modifier.length; i++) {
      modifier[i]['strictSelection']
        ? strictSelection.push(modifier[i]['id'])
        : '';
      for (let j = 0; j < modifier[i]['items'].length; j++) {
        if (
          modifier[i]['items'][j]['selectedQty'] != 0 &&
          modifier[i]['items'][j]['inStock']
        ) {
          if (this.reqaddOnsArray.length === 0) {
            let obj = {
              id: modifier[i]['id'],
              selections: [
                {
                  id: modifier[i]['items'][j]['id'],
                  quantity: modifier[i]['items'][j]['selectedQty'],
                },
              ],
            };
            this.reqaddOnsArray.push(obj);
          } else {
            let filterData = this.reqaddOnsArray.filter(
              (data) => data.id === modifier[i]['id']
            );
            if (filterData.length != 0) {
              let x = {
                id: modifier[i]['items'][j]['id'],
                quantity: modifier[i]['items'][j]['selectedQty'],
              };
              filterData[0]['selections'].push(x);
            } else {
              let obj = {
                id: modifier[i]['id'],
                selections: [
                  {
                    id: modifier[i]['items'][j]['id'],
                    quantity: modifier[i]['items'][j]['selectedQty'],
                  },
                ],
              };
              this.reqaddOnsArray.push(obj);
            }
          }
        }
      }
    }
    if (strictSelection.length != 0) {
      if (this.reqaddOnsArray.length === 0) {
        this.strictaddons = true;
      } else {
        let mid = [];
        this.reqaddOnsArray.forEach((data) => {
          mid.push(data['id']);
        });
        strictSelection.forEach((ids) => {
          if (mid.includes(ids)) {
            this.strictaddons = false;
          } else {
            this.strictaddons = true;
          }
        });
      }
    } else {
      this.strictaddons = false;
    }
    if (this.strictaddons) {
      this.commonFunction.displaySnackBarMessage(
        'Please select mandatory addons',
        'failure'
      );
      this.isClicked = this.loaderOverlayService.hideShimmerBtn();
      this.addItemEvent = false;
      return;
    } else {
      return this.reqaddOnsArray;
    }
  }
  public reqBodyCondimentsTab(modifier) {
    this.reqCondimentsArray = [];
    let strictSelection = [];
    for (let i = 0; i < modifier.length; i++) {
      modifier[i]['strictSelection']
        ? strictSelection.push(modifier[i]['id'])
        : '';
      for (let j = 0; j < modifier[i]['items'].length; j++) {
        if (
          modifier[i]['items'][j]['selectedQty'] != 0 &&
          modifier[i]['items'][j]['inStock']
        ) {
          if (this.reqCondimentsArray.length === 0) {
            let obj = {
              id: modifier[i]['id'],
              selections: [
                {
                  id: modifier[i]['items'][j]['id'],
                  quantity: modifier[i]['items'][j]['selectedQty'],
                },
              ],
            };
            this.reqCondimentsArray.push(obj);
          } else {
            let filterData = this.reqCondimentsArray.filter(
              (data) => data.id === modifier[i]['id']
            );
            if (filterData.length != 0) {
              let x = {
                id: modifier[i]['items'][j]['id'],
                quantity: modifier[i]['items'][j]['selectedQty'],
              };
              filterData[0]['selections'].push(x);
            } else {
              let obj = {
                id: modifier[i]['id'],
                selections: [
                  {
                    id: modifier[i]['items'][j]['id'],
                    quantity: modifier[i]['items'][j]['selectedQty'],
                  },
                ],
              };
              this.reqCondimentsArray.push(obj);
            }
          }
        }
      }
    }
    if (strictSelection.length != 0) {
      if (this.reqCondimentsArray.length === 0) {
        this.strictCondiments = true;
      } else {
        let mid = [];
        this.reqCondimentsArray.forEach((data) => {
          mid.push(data['id']);
        });
        strictSelection.forEach((ids) => {
          if (mid.includes(ids)) {
            this.strictCondiments = false;
          } else {
            this.strictCondiments = true;
          }
        });
      }
    } else {
      this.strictCondiments = false;
    }
    if (this.strictCondiments) {
      this.commonFunction.displaySnackBarMessage(
        'Please select mandatory condiments',
        'failure'
      );
      this.isClicked = this.loaderOverlayService.hideShimmerBtn();
      this.addItemEvent = false;
      return;
    } else {
      return this.reqCondimentsArray;
    }
  }
  public getactivebasket(selectedItem) {
    this.cartService
      .getActiveBasket()
      .pipe(takeUntil(this.endsubs$))
      .subscribe(
        (res) => {
          if (!res['response']['basketId']) {
            this.createbasket(selectedItem);
          } else {
            this.basketId = res['response']['basketId'];
            sessionStorage.setItem('basketId', this.basketId);
            this.makeReqBody(selectedItem);
          }
        },
        (error) => {
          this.isClicked = this.loaderOverlayService.hideShimmerBtn();
          this.addItemEvent = false;
          this.showError(error);
        }
      );
  }
  public createbasket(selectedItem) {
    let storeId = sessionStorage.getItem('storeId');
    let requestBody = {
      channel: 'app',
      storeId: storeId,
    };
    this.cartService
      .createBasket(requestBody)
      .pipe(takeUntil(this.endsubs$))
      .subscribe(
        (res) => {
          if (res['response']) {
            this.basketId = res['response']['id'];
            sessionStorage.setItem('basketId', this.basketId);
            this.makeReqBody(selectedItem);
          } else {
            this.commonFunction.displaySnackBarMessage(
              'Unable to create basket for this request',
              'failure'
            );
            this.isClicked = this.loaderOverlayService.hideShimmerBtn();
            this.addItemEvent = false;
          }
        },
        (error) => {
          this.commonFunction.displaySnackBarMessage(
            error.error.response[0],
            'failure'
          );
          this.addItemEvent = false;
          this.isClicked = this.loaderOverlayService.hideShimmerBtn();
        }
      );
  }
  public matchedOptionList;
  public matchedOptionListNew = [];
  public itemForUpdate;
  public addItemInBasket(requestBody, item, allBasketItem) {
    let snackbarData = JSON.parse(localStorage.getItem('snackbarData'));
    let sbItem = snackbarData && snackbarData['response']['items'];
    let matchedItem;
    let isequal: boolean;
    let matchedItemCloned;
    if (sbItem && sbItem.length != 0) {
      matchedItem = sbItem.filter((data) => +data.id === +item.id);
      if (matchedItem.length != 0) {
        matchedItemCloned = matchedItem.map((a) => {
          return { ...a };
        });
        matchedItemCloned.forEach((element) => {
          if (element.options) {
            element.options.forEach((elm) => {
              elm['selections'].forEach((el) => {
                delete el['name'];
                delete el['price'];
                delete el['priceWithoutTax'];
                delete el['inStock'];
              });
            });
          } else {
            this.addNewItem = false;
            this.itemForUpdate = matchedItem[0];
          }
        });
      } else {
        this.addNewItem = true;
      }
    } else {
      this.addNewItem = true;
    }
    if (!this.addNewItem) {
      if (requestBody['options'] && requestBody['options'].length !== 0) {
        let currentReqsbody = JSON.stringify(requestBody['options']);
        matchedItemCloned.forEach((itemss) => {
          let existReq = JSON.stringify(itemss['options']);
          if (currentReqsbody === existReq) {
            this.matchedOptionListNew.push(existReq);
          }
        });
        if (this.matchedOptionListNew.length === 0) {
          isequal = this.isEqual(requestBody['options'], matchedItemCloned);
          isequal ? (this.addNewItem = false) : (this.addNewItem = true);
          if (isequal) {
            this.itemForUpdate = matchedItemCloned[0];
          }
        } else {
          this.addNewItem = false;
        }
      } else {
        this.addNewItem = false;
      }
    }
    if (!this.addNewItem) {
      if (!isequal) {
        matchedItemCloned.forEach((element) => {
          let existReq = JSON.stringify(element['options']);
          if (existReq === this.matchedOptionListNew[0]) {
            this.itemForUpdate = element;
          }
        });
      }
    }
    if (this.addNewItem) {
      this.addItem(requestBody);
    } else {
      this.updateLineItemApi(allBasketItem, item);
    }
  }
  public isEqual(requestBody, matchedItemCloned) {
    let currentReqsbody_id = [];
    let matchedItemCloned_id = [];
    requestBody.forEach((element) => {
      currentReqsbody_id.push(element['id']);
      element['selections'].forEach((el) => {
        currentReqsbody_id.push(el['id']);
      });
    });
    matchedItemCloned[0]['options'].forEach((element) => {
      matchedItemCloned_id.push(element['id']);
      element['selections'].forEach((el) => {
        matchedItemCloned_id.push(el['id']);
      });
    });
    let isSameArray = currentReqsbody_id.every((ai) =>
      matchedItemCloned_id.includes(ai)
    );
    return isSameArray;
  }
  public addItem(requestBody) {
    if (requestBody['basketId'] != 'null') {
      this.cartService.addItemToBasket(requestBody).subscribe(
        (res) => {
          let reqBody = { ...requestBody };
          this.localCart(reqBody);
         // this.addToCartProductGA(this.selectedItemGA);
          this.backTo();
        },
        (error) => {
          this.showError(error);
          this.addItemEvent = false;
        }
      );
    } else {
      this.addItemEvent = false;
    }
  }
  public finalitem;
  public updateLineItemApi(allBasketItem, item) {
    let basketId = this.storageService.getBasketId();
    let reqBody = {
      basketId: basketId,
      lineItemId: this.itemForUpdate['lineItemId'],
      id: this.itemForUpdate['id'],
      options: this.itemForUpdate['options']
        ? this.itemForUpdate['options']
        : [],
      quantity: this.itemForUpdate['quantity'] + 1,
    };
    this.cartService
      .updateLineItem(reqBody)
      .pipe(takeUntil(this.endsubs$))
      .subscribe(
        (res) => {
          let reqstBody = { ...reqBody };
          this.localCart(reqstBody);
          this.backTo();
        },
        (error) => {
          this.showError(error);
        }
      );
  }
  public localCart(requestBody) {
    let reqBody = { ...requestBody };
    reqBody['myprice'] = this.selectedItem.defaultPrice;
    reqBody['time'] = new Date().toLocaleString();
    let localcartItem = JSON.parse(sessionStorage.getItem('localcartItem'));
    let localCart = [];
    localcartItem ? (localCart = localcartItem) : '';
    localCart.push(reqBody);
    sessionStorage.setItem('localcartItem', JSON.stringify(localCart));
  }
  public getbasketItem() {
    let basketId = this.storageService.getBasketId();
    let data = {
      basketId: basketId,
    };
    this.cartService
      .getbasketItem(data)
      .pipe(takeUntil(this.endsubs$))
      .subscribe(
        (res) => {
          localStorage.setItem('snackbarData', JSON.stringify(res));
          this.backTo();
        },
        (error) => {
          this.showError(error);
        }
      );
  }
  public showError(error) {
    this.commonFunction.displaySnackBarMessage(
      error.error.response[0],
      'failure'
    );
    this.isClicked = this.loaderOverlayService.hideShimmerBtn();
  }
  public saveToFav(event) {
    let reqBodyy = {
      productId: event['item'].id,
      productSkuCode: event['item'].sku,
      quantity: 1,
      isFavorite: event['isFav'],
    };
    let options = event['item']['options'];
    if (!event['item']['options']) {
      reqBodyy['modifiers'] = [];
    } else if (
      !event['item']['options']['addons'] &&
      !event['item']['options']['condiments'] &&
      !event['item']['options']['customization']
    ) {
      reqBodyy['modifiers'] = [];
    } else if (
      event['item']['options']['addons'] &&
      event['item']['options']['customization']
    ) {
      let customization_modifier =
        event['item']['options']['customization']['modifiersItems'];
      let addons_modifier =
        event['item']['options']['addons']['modifiersItems'];
      let returnData_customise = this.loopForCustoimseTab(
        customization_modifier
      );
      let returnData_addons = this.loopForAddonsTab(addons_modifier);
      let final_modifier = [...returnData_customise, ...returnData_addons];
      reqBodyy['modifiers'] = final_modifier;
    } else if (
      options['customization'] &&
      !options['addons'] &&
      !options['condiments']
    ) {
      let modifier =
        event['item']['options']['customization']['modifiersItems'];
      let returnData = this.loopForCustoimseTab(modifier);
      reqBodyy['modifiers'] = returnData;
    } else if (
      !options['customization'] &&
      options['addons'] &&
      !options['condiments']
    ) {
      let addons_modifier =
        event['item']['options']['addons']['modifiersItems'];
      let returnData_addons = this.loopForAddonsTab(addons_modifier);
      reqBodyy['modifiers'] = returnData_addons;
    } else if (
      options['customization'] &&
      !options['addons'] &&
      options['condiments']
    ) {
      let modifier =
        event['item']['options']['customization']['modifiersItems'];
      let returnData_customise = this.loopForCustoimseTab(modifier);
      let condiments_modifier =
        event['item']['options']['condiments']['modifiersItems'];
      let returnData_condiments =
        this.loopForCondimentsTab(condiments_modifier);
      let final_modifier = [...returnData_customise, ...returnData_condiments];
      reqBodyy['modifiers'] = final_modifier;
    } else if (
      options['customization'] &&
      options['addons'] &&
      options['condiments']
    ) {
      let modifier =
        event['item']['options']['customization']['modifiersItems'];
      let returnData_customise = this.loopForCustoimseTab(modifier);
      let addons_modifier =
        event['item']['options']['addons']['modifiersItems'];
      let returnData_addons = this.loopForAddonsTab(addons_modifier);
      let condiments_modifier =
        event['item']['options']['condiments']['modifiersItems'];
      let returnData_condiments =
        this.loopForCondimentsTab(condiments_modifier);
      let final_modifier = [
        ...returnData_customise,
        ...returnData_addons,
        ...returnData_condiments,
      ];
      reqBodyy['modifiers'] = final_modifier;
    }
    this.menuService
      .saveFavourite(reqBodyy)
      .pipe(takeUntil(this.endsubs$))
      .subscribe(
        (res) => {
          this.clearHomeMenuFavList();
          this.reloadFavMenuHome();
          if (res['status'] === 200) {
            this.showSnackbar(res['status'], event['isFav']);
          } else {
            this.showSnackbar(res['status'], event['isFav']);
          }
        },
        (error) => { }
      );
  }
  public clearHomeMenuFavList() {
    this.menuService.clearReorderMenuCache();
    this.menuService.clearFavItemCache();
  }
  public reloadFavMenuHome() {
    this.menuService.reorderMenuCache().subscribe((res) => { });
    this.menuService.getFavMenuItemCache().subscribe((res) => {
      sessionStorage.setItem('favouriteItem', JSON.stringify(res['response']));
    });
  }
  public showSnackbar(status, isFav) {
    let mssg;
    if (status === 200) {
      isFav
        ? (mssg = 'Product added to Favourite menu')
        : (mssg = 'Product Removed from Favourite menu');
    } else {
      this.commonFunction.displaySnackBarMessage(mssg, 'failure');
    }
  }
  public loopForCustoimseTab(modifier) {
    this.customiseArray = [];
    for (let i = 0; i < modifier.length; i++) {
      for (let j = 0; j < modifier[i]['items'].length; j++) {
        if (modifier[i]['items'][j]['click']) {
          let obj = {
            modifierId: modifier[i]['items'][j]['id'],
            skuCode: modifier[i]['items'][j]['sku'],
            quantity: 1,
          };
          this.customiseArray.push(obj);
        }
      }
    }
    return this.customiseArray;
  }
  public loopForAddonsTab(modifier) {
    this.addOnsArray = [];
    for (let i = 0; i < modifier.length; i++) {
      for (let j = 0; j < modifier[i]['items'].length; j++) {
        if (modifier[i]['items'][j]['selectedQty'] != 0) {
          let obj = {
            modifierId: modifier[i]['items'][j]['id'],
            skuCode: modifier[i]['items'][j]['sku'],
            quantity: modifier[i]['items'][j]['selectedQty'],
          };
          this.addOnsArray.push(obj);
        }
      }
    }
    return this.addOnsArray;
  }
  public loopForCondimentsTab(modifier) {
    this.condimentsArray = [];
    for (let i = 0; i < modifier.length; i++) {
      for (let j = 0; j < modifier[i]['items'].length; j++) {
        if (modifier[i]['items'][j]['selectedQty'] != 0) {
          let obj = {
            modifierId: modifier[i]['items'][j]['id'],
            skuCode: modifier[i]['items'][j]['sku'],
            quantity: modifier[i]['items'][j]['selectedQty'],
          };
          this.condimentsArray.push(obj);
        }
      }
    }
    return this.condimentsArray;
  }
  public getData(data) {
    this.titleData.push(data);
  }
  public applyReward(): void {
    this._bottomSheet.open(ApplyRewardDialogComponent, {
      backdropClass: 'light-backdrop',
      panelClass: 'full_width_panel',
    });
  }
  public expandImage(img: any) {
    const dialogRef = this.dialog.open(ExpandImageDialogComponent, {
      width: '600px',
      panelClass: 'expand-image-dialog',
      data: { storeImage: img },
    });
  }
  /**
   * Method to load latest menu by storeId
   */
  public refreshMenu() {
    let shopId = sessionStorage.getItem('storeId');
    if (shopId) {
      this.isClicked = true;
      let requestPayload = {
        storeId: shopId,
        'channel':'&channel=mop-pickup'
      };
      this.menuService
        .getMenuList(requestPayload)
        .pipe(
          retryWhen((err) => {
            return err.pipe(delay(1000), take(3));
          })
        )
        .subscribe(
          (res) => {
            if (res['response'] && res['response'].length !== 0) {
              this.checkOOS(res);
              this.isClicked = false;
              res['response'].sort(
                (a, b) =>
                  parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
              );
              res['response'].forEach((sub) => {
                sub['subCategories'].sort(
                  (a, b) =>
                    parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
                );
              });
              res['response'] = res['response'].filter(
                (itemss) => !itemss.hideForCustomer
              );
              res['response'].forEach((sub) => {
                sub['subCategories'] = sub['subCategories'].filter(
                  (itemss) => !itemss.hideForCustomer
                );
                sub['subCategories'].forEach((itm) => {
                  itm['items'] = itm['items'].filter(
                    (itemss) => !itemss.hideForCustomer
                  );
                });
              });
              localStorage.setItem(
                'menuListItem',
                LZString.compress(JSON.stringify(res['response']))
              );
            }
          },
          (error) => {
            this.isClicked = false;
          }
        );
    }
  }
  /**
* Method to check product oos
@param res contains latest menu list
*/
  checkOOS(res) {
    let selectedItem = JSON.parse(localStorage.getItem('selectedItem'));
    let matched: Object;
    let count: number = 0;
    res['response'].forEach((data) => {
      if (data['subCategories']) {
        data['subCategories'].forEach((itm) => {
          if (itm['items']) {
            matched = itm['items'].find(
              (prod) => +prod.id === +selectedItem.id
            );
            if (matched) {
              count += 1;
              this.checkItem(matched, selectedItem, count);
            }
          }
        });
      }
    });
  }
  /**
   * Method to highlight oos product
   */
  checkItem(matched, selectedItem, count) {
    if (count === 1) {
      if (matched['inStock'] != selectedItem['inStock']) {
        localStorage.setItem('selectedItem', JSON.stringify(matched));
        let isLoggedIn = this.commonFunction.verifyLoggedInUser();
      }
    }
  }
  config: SwiperOptions = {
    allowTouchMove: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
  };
  public customSelection(cutomisationData) {
    let a = JSON.parse(sessionStorage.getItem('defaultSelections'));
    let b = cutomisationData['modifiersItems'];
    let a1 = JSON.stringify(a);
    let b1 = JSON.stringify(b);
    a1 === b1 ? (this.isdefault = true) : (this.isdefault = false);
  }
  public customSelectionFav(cutomisationData) {
    let a = JSON.parse(sessionStorage.getItem('defaultSelectionsFav'));
    let b = cutomisationData['modifiersItems'];
    let a1 = JSON.stringify(a);
    let b1 = JSON.stringify(b);
    a1 === b1 ? (this.isdefault = true) : (this.isdefault = false);
  }
  public customSelectionRegular(cutomisationData) {
    let a = JSON.parse(sessionStorage.getItem('defaultSelectionsRegular'));
    let b = cutomisationData['modifiersItems'];
    let a1 = JSON.stringify(a);
    let b1 = JSON.stringify(b);
    a1 === b1 ? (this.isdefault = true) : (this.isdefault = false);
  }
  public baristaMessage() {
    let barsitaGroupTwo = sessionStorage.getItem('barsitaGroupTwo');
    if (barsitaGroupTwo === 'Product Description') {
      this.baristaInfo = this.commonFunction.displayBristaMessage(
        'Product Description'
      );
    }
  }
  /**
   * Method to display selected product on page load
   */
  loadProduct() {
    let storeId = sessionStorage.getItem('storeId');
    this.urlPath = this.router.url.split('/');
    let selectedItem = JSON.parse(localStorage.getItem('selectedItem'));
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    let menu = localStorage.getItem('menuListItem');
    this.categoryName = this.urlPath[1];
    this.productName = this.urlPath[2];
    this.category = this.categoryName.replace(/-/g, ' ');
    // With this (dynamic normalization for special characters):
   this.category = decodeURIComponent(this.categoryName)
  .replace(/-/g, ' ')
  .replace(/\s?s\s/gi, "'s ")
  .replace(/&/g, 'and')
  .replace(/[’‘]/g, "'")
  .replace(/[éè]/gi, 'e')
  .replace(/[#+/\\]/g, '')
  .replace(/\s+/g, ' ')
  .trim();
    this.product = this.productName.replace(/-/g, ' ');
    if (menu) {
      let menuListItem = JSON.parse(LZString.decompress(menu));
      if (selectedItem) {
        let name = selectedItem.name;
        let productName = this.urlPath[2];
        name = name.replace(/-/g, ' ').toLowerCase();
        name = name.replace(/  +/g, ' ').toLowerCase();
        productName = productName.replace(/-/g, ' ').toLowerCase();
        productName = productName.replace(/  +/g, ' ').toLowerCase();
        name.includes("'") ? (name = name.replace(/'/g, ' ')) : '';
        name.includes('&') ? (name = name.replace(/&/g, 'and')) : '';
        name.includes('è') ? (name = name.replace(/è/g, 'e')) : '';
        name.includes('É') ? (name = name.replace(/É/g, 'E')) : '';
        name.includes('#') ? (name = name.replace(/#/g, '')) : '';
        name.includes('+') ? (name = name.replace(/\+/g, '')) : '';
        name.includes('/') ? (name = name.replace(/\//g, '')) : '';
        name.includes('-') ? (name = name.replace(/\-/g, '')) : '';
        name.includes('\\') ? (name = name.replace(/\\/g, '')) : '';
        let filterCategory = menuListItem.find(
          (data) =>
            data.name.replace(/-/g, ' ').toLowerCase() ===
            this.category.toLowerCase()
        );
        if (filterCategory) {
          name.toString() === productName.toString()
            ? this.getSelectedItem(isLoggedIn)
            : this.findProduct();
        } else {
          this.router.navigate(['/ordering']);
        }
      } else {
        this.filterFromDummy(menuListItem);
      }
    } else {
    }
  }
  /**
* Method to get menu of particular store
@param shopId is store id
*/
  public getMenus(shopId) {
    sessionStorage.setItem('storeId', shopId);
    let requestPayload = {
      storeId: shopId,
    };
    this.menuService
      .getMenuCache(requestPayload)
      .pipe(
        retryWhen((err) => {
          return err.pipe(delay(1000), take(3));
        })
      )
      .subscribe(
        (res) => {
          if (res['response'] && res['response'].length === 0) {
            sessionStorage.setItem('menuFound', 'no');
          } else {
            sessionStorage.removeItem('menuFound');
            sessionStorage.setItem(
              'storeMenu',
              LZString.compress(JSON.stringify(res['response']))
            );
            res['response'].sort(
              (a, b) => parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
            );
            res['response'].forEach((sub) => {
              sub['subCategories'].sort(
                (a, b) =>
                  parseFloat(a.displayOrder) - parseFloat(b.displayOrder)
              );
            });
            res['response'] = res['response'].filter(
              (itemss) => !itemss.hideForCustomer
            );
            res['response'].forEach((sub) => {
              sub['subCategories'] = sub['subCategories'].filter(
                (itemss) => !itemss.hideForCustomer
              );
              sub['subCategories'].forEach((itm) => {
                itm['items'] = itm['items'].filter(
                  (itemss) => !itemss.hideForCustomer
                );
              });
            });
            localStorage.setItem(
              'menuListItem',
              LZString.compress(JSON.stringify(res['response']))
            );
            this.filterProduct(res['response']);
          }
        },
        (error) => { }
      );
  }
  /**
* Method to get menu of particular store
@param shopId is store id
*/
  findProduct() {
    let categoryName = this.urlPath[1];
    let productName = this.urlPath[2];
    this.category = categoryName.replace(/-/g, ' ');
    this.product = productName.replace(/-/g, ' ');
    let menu = localStorage.getItem('menuListItem');
    if (menu) {
      let menuListItem = JSON.parse(LZString.decompress(menu));
      this.filterProduct(menuListItem);
    } else {
    }
  }
  /**
   * Method to filter product and category
   */
  filterProduct(menuListItem) {
    let product;
    let filterCategory = menuListItem.find(
      (data) =>
        data.name.replace(/-/g, ' ').toLowerCase() ===
        this.category.toLowerCase()
    );
    if (filterCategory) {
      filterCategory['subCategories'].forEach((data) => {
        data['items'].forEach((itm) => {
          let name = itm.name.trim();
          name.includes('&') ? (name = name.replace(/&/g, 'and')) : '';
          name.includes('è') ? (name = name.replace(/è/g, 'e')) : '';
          name.includes('É') ? (name = name.replace(/É/g, 'E')) : '';
          name.includes('#') ? (name = name.replace(/#/g, '')) : '';
          name.includes('+') ? (name = name.replace(/\+/g, '')) : '';
          name.includes('/') ? (name = name.replace(/\//g, '')) : '';
          name.includes('-') ? (name = name.replace(/\-/g, '')) : '';
          name.includes('\\') ? (name = name.replace(/\\/g, '')) : '';
          name = name.replace(/-/g, '').toLowerCase();
          name = name.replace(/[\])}[{(]/g, '').toLowerCase();
          name = name.replace(/  +/g, ' ').toLowerCase();
          if (name === this.product.toLowerCase()) {
            product = itm;
          }
        });
      });
    } else {
      this.router.navigate(['/ordering']);
    }
    if (product) {
      localStorage.setItem('selectedItem', JSON.stringify(product));
      let isLoggedIn = this.commonFunction.verifyLoggedInUser();
      this.getSelectedItem(isLoggedIn);
    } else {
      this.router.navigate(['/ordering']);
    }
  }
  /**
   * Method to filter product from dummy menu
   */
  filterFromDummy(menuListItem) {
    let product = [];
    if (menuListItem) {
      menuListItem.forEach((menuitem) => {
        menuitem['subCategories'].forEach((subcat) => {
          subcat['items'].forEach((itm) => {
            itm['inStock'] = true;
            let itemName = itm.name;
            itemName.includes('&')
              ? (itemName = itemName.replace(/&/g, 'and'))
              : '';
            itemName.includes('è')
              ? (itemName = itemName.replace(/è/g, 'e'))
              : '';
            itemName.includes('É')
              ? (itemName = itemName.replace(/É/g, 'E'))
              : '';
            let pname = itemName.replace(/-/g, '').toLowerCase();
            pname = pname.replace(/[\])}[{(]/g, '').toLowerCase();
            pname = pname.replace(/  +/g, ' ').toLowerCase();
            if (pname === this.product.toLowerCase()) {
              product.push(itm);
            }
          });
        });
      });
      if (product.length != 0) {
        this.selectedItem = product[0];
        localStorage.setItem('selectedItem', JSON.stringify(this.selectedItem));
        let isLoggedIn = this.commonFunction.verifyLoggedInUser();
        this.getSelectedItem(isLoggedIn);
      } else {
        this.router.navigate(['/ordering']);
      }
    }
  }
  /**
   * Method to show location alert popup - when location is off forcefully
   */
  public showLocationAlertPopup(): void {
    const dialogRef = this.dialog.open(LocationAlertDialogComponent, {
      backdropClass: 'blur_backdrop',
      width: '400px',
      height: '300px',
      panelClass: 'dialog-no-padding',
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }
  customizePanelClickGA(customizeTitle) {
    let itemList = this.catItem.split(',');
    let itemVariantList: any;
    if (itemList.length > 5) {
      itemVariantList = itemList.slice(0, 5);
    } else {
      itemVariantList = itemList;
    }
    if (customizeTitle == 'CUSTOMISE YOUR ORDER') {
      dataLayer.push({
        event: 'product_detail_customise_click',
        userID: this.userId,
        user_type: this.userType,
        tier: this.tierType,
        item_variant1: itemVariantList[0] ? itemVariantList[0] : 'NA',
        item_variant2: itemVariantList[1] ? itemVariantList[1] : 'NA',
        item_variant3: itemVariantList[2] ? itemVariantList[2] : 'NA',
        item_variant4: itemVariantList[3] ? itemVariantList[3] : 'NA',
        item_variant5: itemVariantList[4] ? itemVariantList[4] : 'NA',
      });
    }
  }
  viewProductDetailGA(item) {
    let data = JSON.parse(sessionStorage.getItem('state'));
    if (data === null || data === undefined) {
      let store = sessionStorage.getItem('storeName');
      data = {
        storeDetails: {
          shopName: store,
        },
      };
    }
    let itemListName = sessionStorage.getItem('itemPage');
    let promoName = sessionStorage.getItem('promo_banner_name');
    let promoId = Number(sessionStorage.getItem('promo_banner_id'));
    let re = new RegExp(promoName, 'g');
    let result = item.name.match(re);
    let promoNameNA = sessionStorage.getItem('promo_name');
    let itemListId;
    if (itemListName == 'Barista Recommends') {
      itemListId = 'L006';
    } else if (itemListName == 'Latest Offerings') {
      itemListId = 'L007';
    } else if (itemListName == 'Menu Products') {
      itemListId = 'L004';
    } else if (itemListName == 'Reorder Favourites') {
      itemListId = 'L001';
    }
    let index = Number(sessionStorage.getItem('productDispIndex'));
    dataLayer.push({
      event: 'view_item',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
      ecommerce: {
        items: [
          {
            item_name: item.name,
            item_id: item.id,
            item_brand: 'Tata',
            affiliation:
              data && data.storeDetails && data.storeDetails.shopName
                ? data.storeDetails.shopName
                : 'NA',
            currency: 'INR',
            item_category: item.parameters[1].value,
            price: item.defaultPrice,
            item_list_name: itemListName,
            item_list_id: itemListId,
            item_variant: 'NA',
            promotion_name: promoId === +item.id ? promoName : promoNameNA,
            index: index,
            quantity: 1,
          },
        ],
      },
    });
  }
  addToCartProductGA(item) {
    let index = Number(sessionStorage.getItem('productDispIndex'));
    let data = JSON.parse(sessionStorage.getItem('state'));
    if (data === null || data === undefined) {
      let store = sessionStorage.getItem('storeName');
      data = {
        storeDetails: {
          shopName: store,
        },
      };
    }
    let promoName = sessionStorage.getItem('promo_banner_name');
    let promoId = Number(sessionStorage.getItem('promo_banner_id'));
    let promoNameNA = sessionStorage.getItem('promo_name');
    let re = new RegExp(promoName, 'g');
    let result = item.name.match(re);
    let snackbar = JSON.parse(localStorage.getItem('snackbarData'));
    let snackbarData = snackbar ? snackbar.response : '';
    let prodQty;
    let itemListId;
    let itemListName = sessionStorage.getItem('itemPage');
    if (itemListName == 'Barista Recommends') {
      itemListId = 'L006';
    } else if (itemListName == 'Latest Offerings') {
      itemListId = 'L007';
    } else if (itemListName == 'Menu Products') {
      itemListId = 'L004';
    } else if (itemListName == 'Reorder Favourites') {
      itemListId = 'L001';
    }
    if (snackbarData) {
      if (snackbarData['items'].length != 0) {
        snackbarData.items.forEach((product) => {
          if (product.id === item.id) {
            prodQty = product.quantity + 1;
          }
        });
      }
    }
    dataLayer.push({
      event: 'add_to_cart',
      userID: this.userId,
      user_type: this.userType,
      tier: this.tierType,
      ecommerce: {
        items: [
          {
            item_name: item.name,
            item_id: item.id,
            item_brand: 'Tata',
            affiliation: data ? data.storeDetails.shopName : 'NA',
            currency: 'INR',
            item_category: item.parameters[1].value,
            price: item.defaultPrice,
            item_list_name: itemListName,
            item_list_id: itemListId,
            item_variant: 'NA',
            promotion_name: promoId === +item.id ? promoName : promoNameNA,
            index: index,
            quantity: prodQty == null ? 1 : prodQty,
          },
        ],
      },
    });
    let gaSelectedItem = {
      item_name: item.name,
      item_id: item.id,
      item_brand: 'Tata',
      affiliation: data ? data.storeDetails.shopName : 'NA',
      currency: 'INR',
      item_category: item.parameters[1].value,
      price: item.defaultPrice,
      item_list_name: itemListName,
      item_list_id: itemListId,
      item_variant: 'NA',
      promotion_name: promoId === +item.id ? promoName : promoNameNA,
      index: index,
      quantity: prodQty == null ? 1 : prodQty,
    };
    if (this.gaData.length > 0) {
      this.gaData.forEach((elem, i) => {
        if (elem.item_id == item.id) {
          this.gaData.splice(i, 1);
        }
      });
      this.gaData.push(gaSelectedItem);
    } else {
      this.gaData.push(gaSelectedItem);
    }
    sessionStorage.setItem('gaData', JSON.stringify(this.gaData));
  }
  productDetailPageGA() {
    dataLayer.push({
      event: 'virtualpageview',
      page_location: window.location.href,
      page_title: this.title,
    });
  }
}
